var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{staticClass:"section copy-section"},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"8","lg":"6"},domProps:{"innerHTML":_vm._s(_vm.fields.copy)}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }